<template>
    <section class="inAboutconBox">
        <div class="wrapper">
            <div class="inAboutHonor">
                <div class="inAboutHonor_titImg">
                    <img src="./images/10.png" />
                    <!-- <div class="title">{{isZhong?'荣誉资质':'COMPANY HONOR'}}</div> -->
                    <div class="title">COMPANY HONOR</div>
                </div>
                <div class="inAboutHonor_ListBox">
                    <!-- 左箭头 -->
                    <div class="fa fa-angle-left honorSwiperLeft"></div>
                    <div class="inAboutHonor_List" v-if="honorList && honorList.length>0">

                         <swiper :options="swiperOptionH" ref="mySwiper">
                            <!-- slides -->
                            <swiper-slide class="inAboutHonor_item" v-for="item in honorList" :key="item.id">
                                <img :src="$root.$TEMP_URL+item.ico" />
                                <div class="name">{{item.title}}</div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <!-- 右箭头 -->
                    <div class="fa fa-angle-right honorSwiperRight"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'swiper/dist/css/swiper.css'
//局部使用
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {getList} from '../../../api'
export default {
    components:{
        swiper,
        swiperSlide,
        isZhong:false
    },
    data() {
        return {
            honorList:[],
            swiperOptionH: {
               loop: true,　　//是否循环轮播
                autoplay: {
                    delay: 5000,//1秒切换一次
                },
　　　　　　　　navigation: {
                    nextEl: '.honorSwiperLeft',
                    prevEl: '.honorSwiperRight',
                }
    　　　　 },
        };
    },
    async created(){
      const isZhong = this.$parent.isZhong;
      let res;
      if(isZhong){
          res = await getList(42);
      }else{
          res = await getList(17);
      }
      this.isZhong= isZhong;
      this.honorList = res.data;
    },
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inAboutconBox {
   background: #fafdfd;  
   padding: 82px 0; 
  .wrapper {
    .inAboutHonor {
      @include flexFather;
      align-items: flex-start;
      .inAboutHonor_titImg {
        width: 335px;
        position: relative;
        img {
            width: 100%;
            height: 410px;
        }
        .title{
            position: absolute;
            line-height: 48px;
            font-size: 34px;
            font-weight: bold;
            color: red;
            top: 78px;
            right: 18px;
            width: 206px;
        }

      }
      .inAboutHonor_ListBox {
          width: 935px;
          height: 698px;
          background: #fff;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .inAboutHonor_List{
              width: 650px;
              .inAboutHonor_item{
                img{
                    width: 100%;
                    height: 450px;
                }
                .name{
                    line-height: 36px;
                    margin-top: 22px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 16px;
                    
                }

              }
              
          }
          .fa{
              color: #bababa;
              font-size: 62px;
              outline: none;
              cursor: pointer;
          }

      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/About/Honor/Honor.vue